import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { CalendarIcon, UserIcon, ArrowLeftIcon, ChevronRightIcon } from 'lucide-react';
interface BlogPostPageProps {
  onNavigate: (page: string) => void;
  blogIndex?: number;
}
const blogs = [{
  title: 'Online Casino Cheating',
  date: 'January 6, 2025',
  author: 'Admin',
  content: ['Online Casino Cheating Special conditions may apply regarding VIP clients, online casino cheating check out our article for more details on this topic.', 'The world of online gaming has evolved significantly over the years, with new technologies and security measures being implemented to ensure fair play for all participants.', 'Various methods have been employed to detect and prevent cheating in online casinos, including advanced algorithms, AI-powered monitoring systems, and strict verification processes.', 'Players are encouraged to always use reputable and licensed platforms to ensure their safety and the integrity of their gaming experience. Always verify the credentials of any online casino before participating.']
}, {
  title: 'Online Casino Cheating',
  date: 'January 6, 2025',
  author: 'Admin',
  content: ['Online Casino Cheating Special conditions may apply regarding VIP clients, online casino cheating check out our article for more details on this topic.', 'The world of online gaming has evolved significantly over the years, with new technologies and security measures being implemented to ensure fair play for all participants.', 'Various methods have been employed to detect and prevent cheating in online casinos, including advanced algorithms, AI-powered monitoring systems, and strict verification processes.', 'Players are encouraged to always use reputable and licensed platforms to ensure their safety and the integrity of their gaming experience.']
}, {
  title: 'Online Casino Cheating',
  date: 'January 6, 2025',
  author: 'Admin',
  content: ['Online Casino Cheating Special conditions may apply regarding VIP clients, online casino cheating check out our article for more details on this topic.', 'The world of online gaming has evolved significantly over the years, with new technologies and security measures being implemented to ensure fair play for all participants.', 'Various methods have been employed to detect and prevent cheating in online casinos, including advanced algorithms, AI-powered monitoring systems, and strict verification processes.', 'Players are encouraged to always use reputable and licensed platforms to ensure their safety and the integrity of their gaming experience.']
}, {
  title: 'Play Online 13 Card Rummy Game For Cash',
  date: 'January 6, 2025',
  author: 'Admin',
  content: ['Play Online 13 Card Rummy Game For Cash. Play online 13 card rummy game for cash if you are looking for an exciting and rewarding card game experience.', 'Rummy is one of the most popular card games worldwide, known for its blend of skill, strategy, and a bit of luck. The 13-card variant is particularly popular in many regions.', 'To get started, choose a reputable platform that offers secure transactions and fair gameplay. Make sure to understand the rules thoroughly before placing any real money bets.', 'Practice with free games first to hone your skills, then gradually move to cash games as you become more confident in your abilities.']
}, {
  title: 'Play Online 13 Card Rummy Game For Cash',
  date: 'January 6, 2025',
  author: 'Admin',
  content: ['Play Online 13 Card Rummy Game For Cash. Play online 13 card rummy game for cash if you are looking for an exciting and rewarding card game experience.', 'Rummy is one of the most popular card games worldwide, known for its blend of skill, strategy, and a bit of luck.', 'To get started, choose a reputable platform that offers secure transactions and fair gameplay.', 'Practice with free games first to hone your skills, then gradually move to cash games as you become more confident in your abilities.']
}, {
  title: 'Online Casino No Deposit Bonus Free Money',
  date: 'January 6, 2025',
  author: 'Admin',
  content: ['Online Casino No Deposit Bonus Free Money. Nevertheless Zhao Cai Jin Bao brings some nice features with exciting bonus opportunities for new players.', 'No deposit bonuses are a popular way for online casinos to attract new players. These bonuses allow you to try out the casino without risking your own money.', 'While these offers sound appealing, it is important to read the terms and conditions carefully. Wagering requirements, maximum withdrawal limits, and game restrictions often apply.', 'Always choose licensed and regulated casinos to ensure that your personal and financial information is protected.']
}];
export function BlogPostPage({
  onNavigate,
  blogIndex = 0
}: BlogPostPageProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const blog = blogs[blogIndex] || blogs[0];
  // Get related posts (exclude current)
  const relatedPosts = blogs.map((b, i) => ({
    ...b,
    index: i
  })).filter((_, i) => i !== blogIndex).slice(0, 3);
  return <main className="flex-grow w-full bg-[#f0f2f5]" data-id="element-605">
      <PageHeader title={blog.title} breadcrumb="Blog Post" onNavigateHome={() => onNavigate('home')} data-id="element-606" />

      <section className="py-16 md:py-20" data-id="element-607">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-608">
          {/* Back button */}
          <motion.button initial={{
          opacity: 0,
          x: -10
        }} animate={{
          opacity: 1,
          x: 0
        }} onClick={() => onNavigate('blogs')} className="inline-flex items-center gap-2 text-brand-charcoal/60 hover:text-brand-red font-medium text-sm mb-8 transition-colors cursor-pointer" data-id="element-609">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-610" />
            Back to all blogs
          </motion.button>

          {/* Article */}
          <motion.article initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-611">
            <div className="p-8 sm:p-12" data-id="element-612">
              {/* Meta */}
              <div className="flex flex-wrap items-center gap-4 text-sm text-brand-charcoal/50 mb-6" data-id="element-613">
                <span className="inline-flex items-center gap-1.5" data-id="element-614">
                  <CalendarIcon className="w-4 h-4" data-id="element-615" />
                  {blog.date}
                </span>
                <span className="inline-flex items-center gap-1.5" data-id="element-616">
                  <UserIcon className="w-4 h-4" data-id="element-617" />
                  {blog.author}
                </span>
              </div>

              {/* Title */}
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-brand-navy mb-8 leading-tight" data-id="element-618">
                {blog.title}
              </h1>

              {/* Content */}
              <div className="prose prose-lg max-w-none" data-id="element-619">
                {blog.content.map((paragraph, i) => <p key={i} className="text-brand-charcoal/75 text-lg leading-relaxed mb-6 last:mb-0" data-id="element-620">
                    {paragraph}
                  </p>)}
              </div>
            </div>
          </motion.article>

          {/* Related Posts */}
          <div className="mt-16" data-id="element-621">
            <h2 className="text-2xl font-bold text-brand-navy mb-8" data-id="element-622">
              Related Posts
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-623">
              {relatedPosts.map(post => <motion.button key={post.index} initial={{
              opacity: 0,
              y: 15
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} onClick={() => onNavigate(`blog-post-${post.index}`)} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 text-left hover:shadow-md transition-shadow cursor-pointer group" data-id="element-624">
                  <p className="text-xs text-brand-charcoal/40 mb-2" data-id="element-625">
                    {post.date}
                  </p>
                  <h3 className="text-base font-bold text-brand-navy mb-3 leading-snug" data-id="element-626">
                    {post.title}
                  </h3>
                  <span className="inline-flex items-center text-[#f05a28] text-sm font-semibold gap-1 group-hover:gap-2 transition-all" data-id="element-627">
                    Read More
                    <ChevronRightIcon className="w-4 h-4 stroke-[2.5]" data-id="element-628" />
                  </span>
                </motion.button>)}
            </div>
          </div>
        </div>
      </section>
    </main>;
}